import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { visibleColumns, sort } from '../../deposits/search/depositReduxConstants';
import { augmentData } from '../../deposits/depositReduxUtils';


export const TSU_REL_DEPOSIT_DATA_TSUNAMI_REQUEST = 'TSU_REL_DEPOSIT_DATA_TSUNAMI_REQUEST';
export const TSU_REL_DEPOSIT_DATA_TSUNAMI_SUCCESS = 'TSU_REL_DEPOSIT_DATA_TSUNAMI_SUCCESS';
export const TSU_REL_DEPOSIT_DATA_TSUNAMI_FAILURE = 'TSU_REL_DEPOSIT_DATA_TSUNAMI_FAILURE';

export const TSU_REL_DEPOSIT_DATA_DEPOSIT_REQUEST = 'TSU_REL_DEPOSIT_DATA_DEPOSIT_REQUEST';
export const TSU_REL_DEPOSIT_DATA_DEPOSIT_SUCCESS = 'TSU_REL_DEPOSIT_DATA_DEPOSIT_SUCCESS';
export const TSU_REL_DEPOSIT_DATA_DEPOSIT_FAILURE = 'TSU_REL_DEPOSIT_DATA_DEPOSIT_FAILURE';


export const TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST = 'TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST';
export const TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS = 'TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS';
export const TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE = 'TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE';

export const TSU_REL_DEPOSIT_DATA_CLEAR = 'TSU_REL_DEPOSIT_DATA_CLEAR';
export const TSU_REL_DEPOSIT_DATA_SORT = 'TSU_REL_DEPOSIT_DATA_SORT';

export const TSU_REL_DEPOSIT_DATA_TOGGLE_COLUMN = 'TSU_REL_DEPOSIT_DATA_TOGGLE_COLUMN';

export const TSU_REL_DEPOSIT_DATA_GEOAGE_REQUEST = 'TSU_REL_DEPOSIT_DATA_GEOAGE_REQUEST';
export const TSU_REL_DEPOSIT_DATA_GEOAGE_SUCCESS = 'TSU_REL_DEPOSIT_DATA_GEOAGE_SUCCESS';
export const TSU_REL_DEPOSIT_DATA_GEOAGE_FAILURE = 'TSU_REL_DEPOSIT_DATA_GEOAGE_FAILURE';

export const TSU_REL_DEPOSIT_DATA_PUBLICATION_REQUEST = 'TSU_REL_DEPOSIT_DATA_PUBLICATION_REQUEST';
export const TSU_REL_DEPOSIT_DATA_PUBLICATION_SUCCESS = 'TSU_REL_DEPOSIT_DATA_PUBLICATION_SUCCESS';
export const TSU_REL_DEPOSIT_DATA_PUBLICATION_FAILURE = 'TSU_REL_DEPOSIT_DATA_PUBLICATION_FAILURE';


const initialState = fromJS({

  fetchedTsunami: false,
  tsunami: {},

  fetchedDeposits: false,
  deposits: [],
  sort,

  fetchedGeologicAges: false,
  geologicAges: [],

  fetchedPublications: false,
  publications: [],

  deleting: false,
  visibleColumns,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const tsunamiRelatedDepositsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TSU_REL_DEPOSIT_DATA_CLEAR:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
        sort: state.get('sort'),
      }));

    case TSU_REL_DEPOSIT_DATA_SORT:
      return state.merge(fromJS({
        deposits: basicSort(action.sort, state.get('deposits')),
        sort: action.sort,
      }));

    case TSU_REL_DEPOSIT_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case TSU_REL_DEPOSIT_DATA_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunami: false,
      }));
    case TSU_REL_DEPOSIT_DATA_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunami: true,
        tsunami: action.response,
      }));
    case TSU_REL_DEPOSIT_DATA_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunami: true,
      }));


    case TSU_REL_DEPOSIT_DATA_DEPOSIT_REQUEST:
      return state.merge(fromJS({
        fetchedDeposits: false,
      }));
    case TSU_REL_DEPOSIT_DATA_DEPOSIT_SUCCESS:
      return state.merge(fromJS({
        fetchedDeposits: true,
        deposits: basicSort(state.get('sort'), augmentData({
          deposits: fromJS(action.response.items),
          geologicAges: state.get('geologicAges'),
          publications: state.get('publications'),
        })),
      }));
    case TSU_REL_DEPOSIT_DATA_DEPOSIT_FAILURE:
      return state.merge(fromJS({
        fetchedDeposits: true,
      }));

    case TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST:
      return state.set('deleting', true);
    case TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS:
    case TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE:
      return state.set('deleting', false);


    case TSU_REL_DEPOSIT_DATA_PUBLICATION_REQUEST:
      return state.merge(fromJS({
        fetchedPublications: false,
      }));
    case TSU_REL_DEPOSIT_DATA_PUBLICATION_SUCCESS: {
      const publications = fromJS(action.response.items);
      return state.merge(fromJS({
        fetchedPublications: true,
        publications,
        deposits: basicSort(state.get('sort'), augmentData({
          deposits: state.get('deposits'),
          publications,
        })),
      }));
    }
    case TSU_REL_DEPOSIT_DATA_PUBLICATION_FAILURE:
      return state.merge(fromJS({
        fetchedPublications: true,
      }));

    case TSU_REL_DEPOSIT_DATA_GEOAGE_REQUEST:
      return state.merge(fromJS({
        fetchedGeologicAges: false,
      }));
    case TSU_REL_DEPOSIT_DATA_GEOAGE_SUCCESS: {
      const geologicAges = fromJS(action.response.items);
      return state.merge(fromJS({
        fetchedGeologicAges: true,
        geologicAges,
        deposits: basicSort(state.get('sort'), augmentData({
          deposits: state.get('deposits'),
          geologicAges,
        })),
      }));
    }
    case TSU_REL_DEPOSIT_DATA_GEOAGE_FAILURE:
      return state.merge(fromJS({
        fetchedGeologicAges: true,
      }));

    default:
      return state;
  }
};
